import { createIcon } from '@chakra-ui/react';

export const HeartFilled = createIcon({
  displayName: 'HeartFilled',
  viewBox: '0 0 24 24',
  path: (
    <path
      id="Heart_Filled_-_L"
      data-name="Heart_Filled_-_L"
      d="M23.308,8.663a6.193,6.193,0,0,0-5.182-3.2,6.122,6.122,0,0,0-4.841,1.875,10.065,10.065,0,0,0-.776.93c-.064.086-.135.188-.2.259-.06-.071-.131-.173-.195-.255a9.559,9.559,0,0,0-.776-.934A6.1,6.1,0,0,0,6.5,5.46a6.221,6.221,0,0,0-5.183,3.2,7.03,7.03,0,0,0-.548,5.111,11.828,11.828,0,0,0,3.244,5.014,33.751,33.751,0,0,0,4.174,3.656l3.427,2.689a1.125,1.125,0,0,0,1.384,0l3.439-2.689a33.93,33.93,0,0,0,4.174-3.656,11.7,11.7,0,0,0,3.244-5A7.059,7.059,0,0,0,23.308,8.663Z"
      transform="translate(-0.313 -3.415)"
      fill="currentColor"
    />
  ),
});
